import React from "react";
import { Construction, Rocket } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";

/**
 * iter150 — Shared "Under Construction" banner used across all Accounting Pro
 * sub-pages until each subsystem is production-ready. Pass in `progress`
 * (0-100) if you want to show the progress bar, and `nextMilestone` to hint
 * what's coming next.
 */
export default function UnderConstructionBanner({
  title = "Under Construction",
  subtitle,
  progress,
  nextMilestone,
  compact = false,
}) {
  return (
    <Card
      className={`border-2 border-amber-500/50 bg-amber-500/5 ${compact ? "" : "shadow-lg"}`}
      data-testid="under-construction-banner"
    >
      <CardHeader className={compact ? "pb-2" : ""}>
        <CardTitle className="flex items-center gap-2">
          <div className="p-1.5 rounded-full bg-amber-500/20">
            <Construction className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          </div>
          <span>{title}</span>
          <Badge variant="outline" className="ml-2 border-amber-500/50 text-amber-700 dark:text-amber-300">
            Building
          </Badge>
        </CardTitle>
        {subtitle && (
          <p className="text-sm text-foreground/80 mt-1">{subtitle}</p>
        )}
      </CardHeader>
      {(progress != null || nextMilestone) && (
        <CardContent className="space-y-3">
          {progress != null && (
            <div>
              <div className="flex items-center justify-between text-xs mb-1">
                <span className="text-muted-foreground">Progress</span>
                <span className="font-medium">{Math.round(progress)}%</span>
              </div>
              <div className="h-2 rounded-full bg-muted overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-amber-500 to-emerald-500 transition-all"
                  style={{ width: `${Math.max(2, Math.min(100, progress))}%` }}
                />
              </div>
            </div>
          )}
          {nextMilestone && (
            <p className="text-xs flex items-start gap-2">
              <Rocket className="h-3.5 w-3.5 shrink-0 mt-0.5 text-emerald-600" />
              <span><strong>Next:</strong> {nextMilestone}</span>
            </p>
          )}
        </CardContent>
      )}
    </Card>
  );
}
